import { useTranslation } from "react-i18next";
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Main from './Main';
import User from './User';
import BusinessList from './BusinessList';
import Business from './Business';
import QRCodes from './QRCodes';
import ApiEndpoints from './ApiEndpoints';
import InvitationMonitor from './InvitationMonitor';
import ConnectionsMonitor from './ConnectionsMonitor';
import MessagesMonitor from './MessagesMonitor';
import InviteSettings from './InviteSettings';
import UsersAdmin from './UsersAdmin';
import AuditLogs from './AuditLogs';
import ProfileTable from './ProfileTable';
import CardsTable from './CardsTable';
import PlansFeatures from './PlansFeatures';
import Subscriptions from './Subscriptions';
import Payments from './Payments';
import Reports from './Reports';
export default function Admin({
  match: {
    path
  }
}) {
  const {
    t
  } = useTranslation();
  return <>
      <Helmet>
        <title>{t("Admin pages - HeresMyInfo.com")}</title>
      </Helmet>
      <Switch>
        <Route exact path={`${path}`} component={Main} />
        <Route exact path={`${path}/users`} component={UsersAdmin} />
        <Route exact path={`${path}/business`} component={BusinessList} />
        <Route exact path={`${path}/qrcodes`} component={QRCodes} />
        <Route exact path={`${path}/api-endpoints`} component={ApiEndpoints} />
        <Route exact path={`${path}/invitations`} component={InvitationMonitor} />
        <Route exact path={`${path}/connections`} component={ConnectionsMonitor} />
        <Route exact path={`${path}/messages`} component={MessagesMonitor} />
        <Route exact path={`${path}/audit`} component={AuditLogs} />
        <Route exact path={`${path}/profiles`} component={ProfileTable} />
        <Route exact path={`${path}/cards`} component={CardsTable} />
        <Route exact path={`${path}/settings/invites`} component={InviteSettings} />
        
        {
        /* Pricing & Billing Admin Routes */
      }
        <Route exact path={`${path}/plans-features`} component={PlansFeatures} />
        <Route exact path={`${path}/subscriptions`} component={Subscriptions} />
        <Route exact path={`${path}/payments`} component={Payments} />
        <Route exact path={`${path}/reports`} component={Reports} />

        <Route path={`${path}/user/:userId`} component={User} />
        <Route path={`${path}/business/:id`} component={Business} />
      </Switch>
    </>;
}